/**
 * PM Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SectionImageFilter } from './sectionImageFilter';


export interface ImageTranslationFilters { 
    imageGallery?: ImageTranslationFilters.ImageGalleryEnum;
    featuredImage?: string;
    sectionImages?: Array<SectionImageFilter>;
    realVariationImage?: string;
    additionalVariationImages?: ImageTranslationFilters.AdditionalVariationImagesEnum;
    angleImages?: object;
    variationImages?: Array<string>;
    syncFeaturedImage?: boolean;
    syncFeaturedVideo?: boolean;
    syncWistiaVideoId?: boolean;
    syncSectionImages?: Array<number>;
    syncAngleSectionImages?: object;
    syncRealVariationImage?: boolean;
    syncVariationImages?: Array<string>;
}
export namespace ImageTranslationFilters {
    export const ImageGalleryEnum = {
        syncAndTranslateAll: 'syncAndTranslateAll',
        syncAndTranslateNew: 'syncAndTranslateNew'
    } as const;
    export type ImageGalleryEnum = typeof ImageGalleryEnum[keyof typeof ImageGalleryEnum];
    export const AdditionalVariationImagesEnum = {
        syncAndTranslateAll: 'syncAndTranslateAll',
        syncAndTranslateNew: 'syncAndTranslateNew'
    } as const;
    export type AdditionalVariationImagesEnum = typeof AdditionalVariationImagesEnum[keyof typeof AdditionalVariationImagesEnum];
}


